import React from "react";

import Image from "next/image";

import BackgroundImage from "public/images/enerflo-background-faq.jpg";

import Heading from "components/heading";

import HeroSection from "../../hero-section";
import { pageInfo } from "./page-info";

const MainHero = () => (
  <div className="relative py-20 md:py-36">
    <Image
      src={BackgroundImage}
      alt="solar project background"
      layout="fill"
      className="object-center object-cover crispImage"
      priority
      loading="eager"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-gray-900 to-transparent" />
    <HeroSection title={pageInfo.title}>
      <HeroSection.Content className="text-white">
        <HeroSection.Header className="md:items-start">
          <Heading tag="h1">{pageInfo.title}</Heading>
        </HeroSection.Header>
        <p className="text-xl text-gray-200 md:max-w-[75%]">{pageInfo.subheading}</p>
      </HeroSection.Content>
    </HeroSection>
  </div>
);

export default MainHero;
